import { NativeStackScreenProps } from "@react-navigation/native-stack";

export const loginRoutes = {
  phone: "Login Phone Screen",
  country: "Login Country Screen",
  code: "Login Code Screen",
} as const;

export type LoginStackParamList = {
  [loginRoutes.phone]: undefined;
  [loginRoutes.code]: undefined;
  [loginRoutes.country]: undefined;
};

export type LoginRoute = keyof LoginStackParamList;

export type LoginScreenProps<T extends LoginRoute = LoginRoute> =
  NativeStackScreenProps<LoginStackParamList, T>;
